import { Link, useLocation } from "react-router-dom";

export default function ContextualAuthLink({ to = "/login", state, children, ...props }) {
  const location = useLocation();
  const authReturnTo = `${location.pathname}${location.search || ""}${location.hash || ""}`;

  return (
    <Link
      {...props}
      to={to}
      state={{
        ...state,
        background: location,
        authReturnTo,
      }}
      data-contextual-auth="true"
    >
      {children}
    </Link>
  );
}
